module.exports = __webpack_public_path__ + "media/images/salesforce-42a71661234f0d37d81467a220e4945f.svg";